import { render } from "./reksadanaDetail.vue?vue&type=template&id=d3d2d780"
import script from "./reksadanaDetail.vue?vue&type=script&lang=js"
export * from "./reksadanaDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__